<template>
  <div class="blacklist-custom-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
       <svg-icon icon-class="blacklist" /> Blacklist
      </div>
      <el-tabs type="card">
        <el-tab-pane label="Main">
          <main-blacklist/>
        </el-tab-pane>
        <el-tab-pane label="Custom">
          <custom-blacklist :projectUID="projectUID" :companyUID="companyUID"/>
        </el-tab-pane>
        <el-tab-pane label="Watch Risk">
          <watch-risk/>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import MainBlacklist from './components/blacklist-main.vue'
import CustomBlacklist from './components/blacklist-custom.vue'
import WatchRisk from '../watchrisk/components/watchrisk-main.vue'
export default {
  props:{
    projectUID: String,
    companyUID: String
  },
  components: {
    MainBlacklist,
    CustomBlacklist,
    WatchRisk
  },
}
</script>

<style>

</style>